import { z } from 'zod';
import { flag, oneOf, oneOfNumbers, str } from '../../navigation/searchParams';

/** The page sizes the "entries" dropdown offers. */
export const AUDIT_LOG_LIMITS = [25, 50, 100, 200] as const;

/** The log search, the level and outcome filters, and how many rows to load. */
export const auditLogsSearch = z.object({
  q: str,
  level: oneOf(['INFO', 'WARN', 'ERROR', 'SECURITY']),
  success: flag,
  limit: oneOfNumbers(AUDIT_LOG_LIMITS),
});
